import { aTypeUpdateProcedure } from 'actions/shared.types';
import H from 'constants/httpMethod.const';
import authenticatedEndpoint from 'utils/backend/authenticatedEndpoint.util';
import jsonEndpoint from 'utils/backend/jsonEndpoint.util';
import fromActionTypeToArray from 'utils/converters/mw/fromActionTypeToArray.util';
import actionOldBe from 'utils/mw/actionOldBe.util';

// TODO: convert to the newest form using actionEndpointBe
const updateProcedure = actionOldBe((salonId, procedure) => ({
  ...authenticatedEndpoint(),
  ...jsonEndpoint(H.put, `salon/${salonId}/procedure/${procedure?.id}/`, {
    ...procedure,
    stylist_id: procedure?.stylist?.id,
  }),
  types: fromActionTypeToArray(aTypeUpdateProcedure),
  params: { salonId, procedure },
}));

export default updateProcedure;
